import styled from 'styled-components'


export const SC_List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 24px;
  margin-top: 14px;
  max-height: 70vh;
  overflow-y: auto;
`
export const SC_CheckItem = styled.div`
  background: #FFFFFF;
  border: 1px solid #EAEAEA;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SC_CheckHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const SC_Date = styled.div`
  font-size: 13px;
  color: #888888;
`

export const SC_Amount = styled.div`
  font-weight: 600;
  font-size: 16px;
`

export const SC_Status = styled.div<{ $status: string }>`
  font-size: 13px;
  font-weight: 500;
  color: ${(p) => p.$status === 'rejected' ? '#FF4D4F' : '#FAAD14'};
`

export const SC_RejectReason = styled.div`
  font-size: 13px;
  color: #FF4D4F;
  background: #FFF1F0;
  padding: 8px;
  border-radius: 6px;
  margin-top: 4px;
`

export const SC_ImageWrapper = styled.div`
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  margin-top: 8px;
  border: 1px solid #f0f0f0;

  .ant-image, img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`
